<template>
  <div class="listing-image-uploader">
    <input
      class="d-none"
      ref="input"
      type="file"
      name="image"
      accept="image/png, image/jpeg, image/jpg"
      @change="setImage"
    />
    <b-card>
      <b-row>
        <b-col
          :cols="12"
          :md="12"
          :lg="7"
          :xl="8">
          <div class="listing-image-uploader__controls mb-3 pr-3">
            <div class="listing-image-uploader__help">
              <h1 class="h5">Crop and Zoom</h1>
              <p>Use the controls below to crop and resize your image</p>
            </div>
            <vue-cropper
              ref="cropper"
              preview=".listing-image-uploader__preview-image"
              dragMode="move"
              :aspectRatio="1"
              :touchDragModeOnDblclick="false"
              :zoomOnTouch="true"
              :cropBoxResizable="true"
            />
            <div class="mt-3">
              <b-button
                class="mr-2"
                @click.prevent="resetCropper"
                variant="light"
                squared="">
                Reset
              </b-button>
              <b-button
                class="mr-2"
                @click.prevent="rotate"
                variant="light"
                squared="">
                Rotate
              </b-button>
              <b-button
                class="mr-2"
                @click.prevent="zoomIn"
                variant="light"
                squared="">
                <font-awesome-icon
                  :icon="['fas', 'search-plus']"/>
              </b-button>
              <b-button
                class="mr-2"
                @click.prevent="zoomOut"
                variant="light"
                squared="">
                <font-awesome-icon
                  :icon="['fas', 'search-minus']"/>
              </b-button>
            </div>
          </div>
        </b-col>
        <b-col
          :cols="12"
          :md="12"
          :lg="5"
          :xl="4">
          <div class="mb-3">
            <div class="listing-image-uploader__help">
              <h1 class="h5">Preview</h1>
              <p>This is how your listing will appear to buyers on ZoopLocal</p>
            </div>
            <div>
              <div
                style="width: 200px;">
                <div class="listing-image-uploader__preview">
                  <div
                    class="listing-image-uploader__preview-image mb-2"/>
                  <div
                    class="listing-image-uploader__preview-description p-2">
                    <h2 class="h2">
                      {{ listing.title || 'Listing Title' }}
                    </h2>
                    <h3 class="h3 text-primary">
                      ${{ listing.price || 100 }}
                    </h3>
                    <b-card-text>
                      {{ listing.description || 'Sample listing description' }}
                    </b-card-text>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <template v-slot:footer>
        <div class="text-right">
          <b-button
            variant="danger"
            squared
            @click="cancel">
            Cancel
          </b-button>
          <b-button
            class="ml-2"
            variant="primary"
            squared
            @click="cropAndSave">
            Crop and Save
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import Reduce from 'image-blob-reduce'

const reduce = Reduce()

export default {
  name: 'ListingImageUploader',
  components: {
    VueCropper,
  },
  props: {
    listing: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      croppedImage: '',
      fileName: '',
      caption: '',
    }
  },
  methods: {
    log() {
      console.log('A modal opened')
    },
    cropAndSave() {
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        this.$emit('submit', {
          fileName: this.fileName,
          data: blob,
          caption: this.caption,
        })
      })
      this.clearInput()
    },
    clearInput() {
      this.$refs.input.value = ''
    },
    cancel() {
      this.clearInput()
      this.$emit('cancel')
    },
    /**
     * Called when the HTML file input changes.
     * Resize the image, then create a cropper instance.
     */
    async setImage(evt) {
      const MAX_DIM = 1000

      this.$emit('select')

      const file = evt.target.files[0]

      const fileCanvas = await reduce
        .toCanvas(file, {
          max: MAX_DIM,
          unsharpAmount: 50,
          unsharpRadius: 0.5,
          quality: 3,
        })

      this.fileName = file.name

      // rebuild cropperjs with the updated source
      this.$refs.cropper.replace(fileCanvas.toDataURL('image/png'))
    },
    rotate() {
      this.$refs.cropper.rotate(90)
    },
    resetCropper() {
      this.$refs.cropper.reset()
    },
    zoomIn() {
      this.$refs.cropper.relativeZoom(0.2)
    },
    zoomOut() {
      this.$refs.cropper.relativeZoom(-0.2)
    },
  },
}
</script>

<style lang="scss" scoped>
.croppa-container {
  background-color: #fff;
  border: 1px solid #000;
}

.listing-image-uploader__preview-image {
  width: 200px;
  height: 200px;
  border-radius: 5px;
  overflow: hidden;
}

.listing-image-uploader__preview-description {
}
</style>
